<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>


          <v-card-text>
            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>

                    <v-layout wrap>
                      <div class="flex md12">

                        <v-text-field :disabled="m"  :label="$t('Code')" v-model="KesenKisi.Kodu"
                          :error-messages="errors.collect('kodu')" v-validate="'required'" data-vv-name="kodu" required>
                        </v-text-field>

                        <v-text-field :label="$t('Name_label')" v-model="KesenKisi.Adi" :error-messages="errors.collect('adi')"
                          v-validate="'required'" data-vv-name="adi" required> </v-text-field>

                        <v-text-field :label="$t('Surname_label')" :error-messages="errors.collect('soyadi')" v-validate="'required'"
                          data-vv-name="soyadi" required v-model="KesenKisi.Soyadi"> </v-text-field>
                      </div>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">
              <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">{{ $t('Update') }}</v-btn>
              <v-btn id="bsil" color="blue darken-1" flat @click="sil()">{{ $t('Delete') }}</v-btn>
            </div>
            <div v-show="k === true">
              <v-btn id="bkaydet" color="blue darken-1" flat @click="Kaydet()">{{$t("save_button")}}</v-btn>
            </div>
            <v-btn color="blue darken-1" flat @click.native="dialog = false">{{$t('Cancel')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>{{$t('Ticket-Agent')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
        </v-text-field>



              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="ekle()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Add-v2', { value: $t('Ticket-Agent')}) }}</span>
                  </span>
                  <v-icon right dark>add_box</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{ $t('Add-v2', { value: $t('Ticket-Agent')}) }}</span>
              </v-tooltip>





      </v-toolbar>
    </v-layout>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
        :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item)" item>
            <td class="text-xs-left">{{ props.item.Kodu }}</td>
            <td class="text-xs-left">{{ props.item.Adi }}</td>
            <td class="text-xs-left">{{ props.item.Soyadi }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t('No-records-searched-for', { value: search3}) }}
        </v-alert>
      </v-data-table>
    </v-card>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  export default {
    data() {
      return {
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        items: [],
        search3: '',
        selected: '',
        m: false,
        k: false,
        dialog: false,

        KesenKisi: {
          ID: null,
          SirketKodu: null,
          Kodu: null,
          Adi: null,
          Soyadi: null,
          PersonelKodu: null,
        },
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        analizkod: '',
        analizadi: '',
        tutar: '',
        oran: '',
        progress: false,
        dictionary: {
          custom: {
            kodu: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            adi: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            soyadi: {
              required: () => this.$t('This-space-cannot-left-blank'),
            }
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params = {
          SirketKodu: credentials.SirketKodu,
        }
        this.progress = true
        this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.progress = false
          this.items = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.progress = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })


      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute
              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }

    },
    methods: {
      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Kesen Kişi Güncelle'
        this.KesenKisi = v

      },
      sil: sil,
      ekle: ekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog
    },
    computed:{
          headers(){
            return [{
            text: this.$t('Code'),
            value: 'Kodu'
          },
          {
            text: this.$t('Name_label'),
            value: 'Adi'
          },
          {
            text: this.$t('Surname_label'),
            value: 'Soyadi'
          }
        ]
        },
    }
  }

  function Kaydet() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.KesenKisi.SirketKodu = credentials.SirketKodu

        var params = this.KesenKisi


        this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanSave', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true

          if (response.body.Status) {

            this.dialog = false
            var params = {
              SirketKodu: credentials.SirketKodu,
            }

            this.progress = true
            this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanList', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.progress = false
              this.items = response.body
            }, (response) => {
              if (response.status === 0) {
                this.progress = false
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.progress = false
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          } else {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true

          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      }
    })
  }



  function ekle() {
      this.dialog = true
      this.KesenKisi.Kodu = null,
      this.KesenKisi.Adi = null,
      this.KesenKisi.Soyadi = null,
      this.dialog_baslik = this.$t('Add-People')
      this.m = false
      this.k = true
      this.$validator.reset()
  }

  function beforeMount() {



  }

  function sil() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.KesenKisi.SirketKodu = credentials.SirketKodu

    var params = this.KesenKisi


    this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanDelete', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

       this.text1 = this.$t(response.body.ResponseMessage)
      this.snackbar = true

      if (response.body.Status) {

        this.dialog = false
        var params = {
          SirketKodu: credentials.SirketKodu,
        }

        this.progress = true
        this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.progress = false
          this.items = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.progress = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })

      } else {
         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true

      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }


  function guncelle(value) {

    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.KesenKisi.SirketKodu = credentials.SirketKodu

        var params = this.KesenKisi

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanUpdate', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true

          if (response.body.Status) {

            this.dialog = false
            var params = {
              SirketKodu: credentials.SirketKodu,
            }

            this.progress = true
            this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanList', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.progress = false
              this.items = response.body
            }, (response) => {
              if (response.status === 0) {
                this.progress = false
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.progress = false
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          } else {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true

          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>